import initialState from '../initialState';
import createReducer from '../createReducer';
import * as orderDetails from './orderDetails';
import * as charges from './charges';
import * as sqc from './sqc';
import * as memo from './memo';
import * as justAsk from './justAsk';
import * as techRoute from './techRoute';
import * as close from './close';
import * as outlets from './outlets';
import * as equipmentOptions from './equipmentOptions';
import * as homeVerify from './homeVerify';
import * as pinReset from './pinReset';
import Immutable from 'immutable';

const rehydrate = (state, action) => {
    if (action.payload.workOrder) {
        state = action.payload.workOrder;
    }
    return state.set('stateReady', true);
};

const setSlideIndex = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'slideIndex'
    ], action.index);
};

const setInitialState = (state) => {
    return state.setIn(['workOrderDetails'], Immutable.fromJS({}));
};

const setShowClosedOrders = (state, action) => {
    return state.setIn(['showClosedOrders'], action.show);
};

const tagUpdateStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateStarted'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateMessage'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateError'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagEditing'
    ], false);
};

const tagUpdateFinished = (state, action) => {

    return state.setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateStarted'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateMessage'
    ], 'Tags updated.').setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateError'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1OriginalSet'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1Original'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2OriginalSet'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2Original'
    ], null);
};

const tagUpdateFailed = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateStarted'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateMessage'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateError'
    ], 'Tag update failed.').setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagEditing'
    ], true);
};

const setTagNumbers = (state, action) => {

    const networkDetails = state.getIn(['workOrderDetails', action.orderId, 'networkDetails', 'details']);

    const tagNo1 = networkDetails.get('tagNo1');
    const tagNo2 = networkDetails.get('tagNo2');
    const tagNo1OriginalSet = networkDetails.get('tagNo1OriginalSet');
    const tagNo2OriginalSet = networkDetails.get('tagNo2OriginalSet');

    if (!tagNo1OriginalSet) {
        state = state.setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1OriginalSet'
        ], true).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1Original'
        ], tagNo1);
    }

    if (!tagNo2OriginalSet) {
        state = state.setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2OriginalSet'
        ], true).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2Original'
        ], tagNo2);
    }

    if (action.tags.action === 'reset') {
        return state.setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1'
        ], state.getIn(['workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1Original'])).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2'
        ], state.getIn(['workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2Original'])).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateMessage'
        ], null).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateError'
        ], null);
    }

    if (action.tags.action !== 'reset') {

        return state.setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo1'
        ], action.tags.tagNo1.substring(0, 7)).setIn([
            'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagNo2'
        ], action.tags.tagNo2.substring(0, 7));

    }

};

const setTagEditing = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagEditing'
    ], action.isEditing).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateMessage'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'networkDetails', 'details', 'tagUpdateError'
    ], null);
};

const handlers = {
    'SET_TAG_EDITING': setTagEditing,
    'SET_TAG_NUMBERS': setTagNumbers,
    'TAG_UPDATE_STARTED': tagUpdateStarted,
    'TAG_UPDATE_FINISHED': tagUpdateFinished,
    'TAG_UPDATE_FAILED': tagUpdateFailed,
    'SET_SHOW_ORDER_CLOSED': setShowClosedOrders,
    'redux-oidc/SESSION_TERMINATED': setInitialState,
    'SET_SLIDE_INDEX': setSlideIndex,
    'persist/REHYDRATE': rehydrate,
    'ADD_MEMO_FINISHED': memo.addMemoFinished,
    'ADD_MEMO_STARTED': memo.addMemoStarted,
    'ADD_MEMO_FAILED': memo.addMemoFailed,
    'SET_NEW_MEMO': memo.setNewMemo,
    'WORK_ORDER_GET_TECH_ROUTE_STARTED': techRoute.getTechRoutedStarted,
    'WORK_ORDER_GET_TECH_ROUTE_FINISHED': techRoute.getTechRouteFinished,
    'WORK_ORDER_GET_STARTED': orderDetails.getWorkOrderStarted,
    'WORK_ORDER_GET_FINISHED': orderDetails.getOrderDetailFinished,
    'WORK_ORDER_GET_FAILED': orderDetails.getOrderDetailFailed,
    'WORK_ORDER_DETAIL_PAGE_OPENED': orderDetails.ordeDetailPageOpened,
    'WORK_ORDER_BY_ORDER_ID_GET_FINISHED': orderDetails.ordeDetailByIdFinished,
    'WORK_ORDER_BY_ORDER_ID_GET_STARTED': orderDetails.ordeDetailByIdStarted,
    'CLEAR_WORK_ORDER_DETAIL': orderDetails.clearOrderDetail,
    'ORDER_HISTORY_REQUEST_STARTED': orderDetails.getOrderHistoryStarted,
    'ORDER_HISTORY_REQUEST_FINISHED': orderDetails.getOrderHistoryFinished,
    'ORDER_HISTORY_REQUEST_FAILED': orderDetails.getOrderHistoryFailed,
    'SET_NEW_CUSTOMER_EMAIL': orderDetails.setNewCustomerEmail,
    'SET_NEW_CUSTOMER_EMAIL_EDIT_MODE': orderDetails.setCustomerEmailEditMode,
    'RESET_CUSTOMER_EMAIL_EDIT': orderDetails.resetCustomerEmailChanges,
    'UPDATE_CUSTOMER_EMAIL_STARTED': orderDetails.updateCustomerEmailStarted,
    'UPDATE_CUSTOMER_EMAIL_FINISHED': orderDetails.updateCustomerEmailFinished,
    'UPDATE_CUSTOMER_EMAIL_FAILED': orderDetails.updateCustomerEmailFailed,
    'UPDATE_CUSTOMER_EMAIL_MESSAGE_RESET': orderDetails.updateCustomerEmailMessageReset,
    'GET_ADDRESS_FROM_BILLER_STARTED': orderDetails.getAddressFromBillerStarted,
    'GET_ADDRESS_FROM_BILLER_FINISHED': orderDetails.getAddressFromBillerFinished,
    'GET_ADDRESS_FROM_BILLER_FAILED': orderDetails.getAddressFromBillerFailed,
    'SQC_GENERATE_FINISHED': sqc.setSqcResults,
    'SQC_GENERATE_FAILED': sqc.setSqcGenerateFailed,
    'SQC_GENERATE_STARTED': sqc.setSqcGenerateStarted,
    'CHARGE_QUANTITY_SET': charges.chargeQuantitySet,
    'CHARGE_ADD_FAILED': charges.chargeAddFailed,
    'CHARGE_ADD_STARTED': charges.chargeAddStarted,
    'CHARGE_ADD_FINISHED': charges.chargeAddFinished,
    'CHARGE_UPDATE_FAILED': charges.chargeAddFailed,
    'CHARGE_UPDATE_STARTED': charges.chargeAddStarted,
    'CHARGE_UPDATE_FINISHED': charges.chargeAddFinished,
    'CHARGE_UPDATE_CANCELLED': charges.chargeUpdateCancelled,
    'CHARGE_COMMENT_SET': charges.chargeCommentSet,
    'JUST_ASK_ADD_FAILED': justAsk.justAskAddFailed,
    'JUST_ASK_ADD_STARTED': justAsk.justAskAddStarted,
    'JUST_ASK_ADD_FINISHED': justAsk.justAskAddFinished,
    'JUST_ASK_UPDATE_FAILED': justAsk.justAskAddFailed,
    'JUST_ASK_UPDATE_STARTED': justAsk.justAskAddStarted,
    'JUST_ASK_UPDATE_FINISHED': justAsk.justAskAddFinished,
    'JUST_ASK_QUANTITY_SET': justAsk.justAskQuantitySet,
    'SET_CLOSE_STEP': close.setCloseStep,
    'CLOSE_CODE_ADD': close.addCloseCode,
    'CLOSE_CODE_REMOVE': close.removeCloseCode,
    'CLOSE_COMMENT_SET': close.setCloseComment,
    'CLOSE_ORDER_STATUS_SET': close.setCloseOrderStatus,
    'OUTLET_OPTIMIZATION_STATUS_SET': close.setOutletOptimizationStatus,
    'DROP_BURY_SET': close.setDropBury,
    'TICKET_REQUEST_ADD': close.addTicketRequest,
    'TICKET_REQUEST_REMOVE': close.removeTicketRequest,
    'ORDER_CLOSE_STARTED': close.orderCloseStarted,
    'ORDER_CLOSE_WAITING': close.orderCloseWaiting,
    'ORDER_CLOSE_FINISHED': close.orderCloseFinished,
    'ORDER_CLOSE_FAILED': close.orderCloseFailed,
    'ORDER_CLOSE_REQUEST_ADD_STARTED': close.setOrderCloseRequestAddStarted,
    'ORDER_CLOSE_REQUEST_ADD_FINISHED': close.setOrderCloseRequestAddFinished,
    'ORDER_CLOSE_REQUEST_ADD_FAILED': close.setOrderCloseRequestAddFailed,
    'SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED': close.submitTruckRollUnnecessaryStarted,
    'SUBMIT_UNNECESSARY_TRUCK_ROLL_FINISHED': close.submitTruckRollUnnecessaryFinished,
    'SUBMIT_UNNECESSARY_TRUCK_ROLL_FAILED': close.submitTruckRollUnnecessaryFailed,
    'SET_IN_HOME_ACCESS': close.setInHomeAccess,
    'SET_NOACCESS_REASON': close.setNoAccessReason,
    'GET_NOACCESS_REASONS_STARTED': close.getNoAccessReasonListStarted,
    'GET_NOACCESS_REASONS_FINISHED': close.getNoAccessReasonListFinished,
    'GET_NOACCESS_REASONS_FAILED': close.getNoAccessReasonListFailed,

    //signal levels associated actions
    'SET_FST_SIGNAL_VALUE': close.setFstSignalValue,
    'GET_DIGITAL_CHANNELS_STARTED': close.getDigitalChannelsStarted,
    'GET_DIGITAL_CHANNELS_FINISHED': close.getDigitalChannelsFinished,
    'GET_DIGITAL_CHANNELS_FAILED': close.getDigitalChannelsFailed,
    'SET_TECHID_SIGNAL_LEVELS': close.setTechIdSignalLevels,

    //delivery proof associated actions
    'SET_DELIVERY_PROOF_IMAGE': close.setDeliveryImage,
    'REMOVE_DELIVERY_PROOF_IMAGE': close.removeDeliveryImage,
    'SET_DELIVERY_PROOF_DESCRIPTION': close.setDeliveryDescription,
    'DELIVERY_PROOF_SUBMIT_STARTED': close.deliveryProofSubmitStarted,
    'DELIVERY_PROOF_SUBMIT_FINISHED': close.deliveryProofSubmitFinished,
    'DELIVERY_PROOF_SUBMIT_FAILED': close.deliveryProofSubmitFailed,
    'DELIVERY_PROOF_INIT': close.initDeliveryProof,
    'SET_DELIVERY_PROOF_BYPASS_FLAG': close.setDeliveryProofBypassFlag,

    'OUTLET_UPDATE': outlets.outletUpdate,
    'OUTLET_UPDATE_APPIAN_STARTED': outlets.outletUpdateAppianStarted,
    'OUTLET_UPDATE_APPIAN_FINISHED': outlets.outletUpdateAppianFinished,
    'OUTLET_UPDATE_APPIAN_FAILED': outlets.outletUpdateAppianFailed,
    'OUTLET_UPDATE_STARTED': outlets.outletUpdateStarted,
    'OUTLET_UPDATE_FINISHED': outlets.outletUpdateFinished,
    'OUTLET_UPDATE_FAILED': outlets.outletUpdateFailed,
    'OUTLET_UPDATE_EQUIPMENT_REFRESHED': outlets.outletUpdateEquipmentRefreshed,
    'EQUIPMENT_HIT_STARTED': outlets.equipmentHitStarted,
    'EQUIPMENT_HIT_FINISHED': outlets.equipmentHitFinished,
    'EQUIPMENT_HIT_FAILED': outlets.equipmentHitFailed,
    'EQUIPMENT_REFRESH_HIT_STARTED': outlets.equipmentRefreshHitStarted,
    'EQUIPMENT_REFRESH_HIT_FINISHED': outlets.equipmentRefreshHitFinished,
    'EQUIPMENT_REFRESH_HIT_FAILED': outlets.equipmentRefreshHitFailed,
    'SET_OUTLET_EXPANDED': outlets.setEquipmentExpanded,
    'EQUIPMENT_OPTION_QTY_SET': equipmentOptions.equipmentOptionQtySet,
    'EQUIPMENT_OPTION_CLEAR': equipmentOptions.equipmentOptionClear,
    'EQUIPMENT_OPTION_SUBMIT_STARTED': equipmentOptions.equipmentOptionSubmitStarted,
    'EQUIPMENT_OPTION_SUBMIT_FINISHED': equipmentOptions.equipmentOptionSubmitFinished,
    'EQUIPMENT_OPTION_SUBMIT_FAILED': equipmentOptions.equipmentOptionSubmitFailed,
    'UNPAIR_PAIR_STARTED': outlets.unpairPairStarted,
    'UNPAIR_PAIR_FINISHED': outlets.unpairPairFinished,
    'UNPAIR_PAIR_FAILED': outlets.unpairPairFailed,
    'SET_TRUCK_ROLL_CLOSE_UNNECESSARY_VALUE': close.setTruckRollUnecessaryValue,
    'SET_TRUCK_ROLL_CLOSE_COMMENT': close.setTruckRollCloseComment,
    'GET_HOME_VERIFY_STARTED': homeVerify.getHomeVerifyStarted,
    'GET_HOME_VERIFY_FINISHED': homeVerify.getHomeVerifyFinished,
    'GET_HOME_VERIFY_FAILED': homeVerify.getHomeVerifyFailed,
    'SET_HOME_VERIFY_STARTED': homeVerify.setHomeVerifyStarted,
    'SET_HOME_VERIFY_FINISHED': homeVerify.setHomeVerifyFinished,
    'SET_HOME_VERIFY_FAILED': homeVerify.setHomeVerifyFailed,
    'SET_HOME_VERIFY_MESSAGE': homeVerify.setHomeVerifyMessage,
    'SET_HOME_VERIFY_STATE': homeVerify.setHomeVerifyState,
    'PIN_RESET_STARTED': pinReset.pinResetStarted,
    'PIN_RESET_FINISHED': pinReset.pinResetFinished,
    'PIN_RESET_FAILED': pinReset.pinResetFailed,
    'PIN_RESET_RESET': pinReset.pinResetReset,
    
    'ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED': orderDetails.asurionPlusEnrollmentStarted,
    'ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED': orderDetails.asurionPlusEnrollmentFinished,
    'ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED': orderDetails.asurionPlusEnrollmentFailed,
    
    'EQUIPMENT_ADD_BY_SERIAL_STARTED': orderDetails.addEquipmentBySerialStarted,
    'EQUIPMENT_ADD_BY_SERIAL_FINISHED': orderDetails.addEquipmentBySerialFinished,
    'EQUIPMENT_ADD_BY_SERIAL_FAILED': orderDetails.addEquipmentBySerialFailed,
    'RESET_CPE_EQUIPMENT_ADD': orderDetails.resetCpeEquipmentAdd,

    'TECH_WORK_ORDER_TRANSFER_STARTED': techRoute.workOrderTransferStarted,
    'TECH_WORK_ORDER_TRANSFER_FINISHED': techRoute.workOrderTransferFinished,
    'TECH_WORK_ORDER_TRANSFER_FAILED': techRoute.workOrderTransferFailed,
    'CLEAR_WORK_ORDER_TRANSFER_STATE': techRoute.clearWorkOrderTransferState
};

export default createReducer(initialState.get('workOrder'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/work-order/workOrderReducer.js